module.exports = __webpack_public_path__ + "static/media/twitter.cedbb4de.png";